export const state = () => ({});

export const mutations = {};

export const getters = {};

export const actions = {
	async updateDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/documents/' + payload.uuid, payload.data)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/profile/documents/' + payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
